import { availableBalanceText } from '../utils/invoiceBalance';
import { useAgreementCashPositionQuery } from './useAgreementCashPositionQuery';

export function useHeaderAvailableBalance(id: string | undefined, status: string | undefined): string | null {
    const query = useAgreementCashPositionQuery(id, status !== undefined && status !== 'draft' && status !== 'dead');
    return availableBalanceText({
        isLoading: query.isLoading,
        isError: query.isError,
        cashPosition: query.data?.cashPosition,
    });
}
